<template>
  <AppHeader>Sample Location</AppHeader>

  <div id="mapbox" style="min-height: 500px; max-width: 100%;"></div>

  <div class="p-4" v-if="lead != null">
    <div class="inline-block w-full px-3 py-2 bg-white shadow rounded-2xl">
      <p class="text-xl text-gray-900">{{ lead.name }} <small>(#{{ lead.id }})</small></p>
      <p class="mt-1" v-if="lead.delivery_person_id"><b>Delivery Person :</b> {{ lead.delivery_person.name }}</p>
      <p class="mt-1"><b>Status :</b> {{ lead.status.toUpperCase() }}</p>
      <p class="mt-1"><b>From :</b> {{ lead.from }}</p>
      <p class="mt-1"><b>Quantity :</b> {{ lead.sample_quantity }}</p>
      <p class="mt-1"><b>Delivery Date :</b> {{ toDate(lead.delivery_date) }}</p>
      <p class="mt-1"><b>Area :</b> {{ lead.area.name }}, {{ lead.district.name }}</p>
      <p class="mt-1">{{ lead.address }}</p>
      <hr class="my-3">
      <p class="mt-1"><b>Payment Amount :</b> {{ toInr(lead.payment_amount) }}</p>
      <p class="mt-1"><b>Payment Date :</b> {{ toDate(lead.payment_date) }}</p>
      <p class="mt-1"><b>Payment Ref :</b> {{ lead.payment_ref }}</p>
      <hr class="my-3">
      <p class="mt-1"><b>Created At :</b> {{ toDate(lead.created_at, true) }}</p>
      <p class="mt-1"><b>Assigned At :</b> {{ toDate(lead.assigned_at, true) }}</p>
    </div>

    <div class="mt-5 text-center space-x-2">
      <a @click="initiateCall(lead.phone)" class="px-4 py-1 text-white bg-blue-700 rounded-full shadow">Call</a>
      <button class="px-4 py-1 text-white bg-green-700 rounded-full shadow" @click="getDirection">Open in Map</button>
      <button class="px-4 py-1 text-white bg-green-700 rounded-full shadow" @click="getDirection">Get Direction</button>
    </div>
  </div>
</template>

<script>
import { Geolocation } from '@capacitor/geolocation';
import mixin from '@/utils/mixin.js';
import SetLocation from '@/utils/CustomerMapControl.js';
import AppHeader from '@/components/common/Header.vue';

export default {
  name: 'ViewLead',
  mixins: [ mixin ],
  components: { AppHeader },
  data() {
    return {
      state: 'idle',
      lead: null,
      map: null,
      marker: null,
    }
  },

  methods: {
    setupMap() {
      mapboxgl.accessToken = this.$store.state.mapboxKey;

      this.map = new mapboxgl.Map({
        container: 'mapbox',
        style: 'mapbox://styles/mapbox/satellite-streets-v11',
        center: [80.2165, 13.0747],
        zoom: 14,
      });

      this.marker = new mapboxgl.Marker({
          color: "#699543",
          draggable: true
        })
        .setLngLat([80.2165, 13.0747])
        .addTo(this.map);

      let geolocate = new mapboxgl.GeolocateControl({ positionOptions: { enableHighAccuracy: true } });

      geolocate.on('geolocate', pos => {
        this.marker.setLngLat([pos.coords.longitude, pos.coords.latitude]);
        this.map.setCenter([pos.coords.longitude, pos.coords.latitude]);
      });

      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.addControl(geolocate);
      this.map.addControl(new SetLocation(this.setLocation), 'bottom-right');
      this.map.on('click', e => {
        this.marker.setLngLat([e.lngLat.lng, e.lngLat.lat]);
      });

      this.checkPermission();
      this.getData();
    },

    getData() {
      this.state = 'loading';

      this.request('GET', 'leads/'+ this.$route.params.id, {}, (resp) => {
        this.isLoading = 'idle';
        if (resp.success) {
          this.lead = resp.data.lead;

          if (this.lead.latitude != null && this.lead.longitude != null && this.lead.latitude != '0.00000000' && this.lead.longitude != '0.00000000') {
            this.marker.setLngLat([this.lead.longitude, this.lead.latitude]);
            this.map.setCenter([this.lead.longitude, this.lead.latitude]);
          }
        }
      });
    },

    setLocation() {
      if (!this.marker) {
        alert('Please click on the Map to set a Location');
        return;
      }
      let pos = this.marker.getLngLat();

      this.request('POST', 'leads/'+ this.$route.params.id +'/location', {latitude: pos.lat, longitude: pos.lng}, (resp) => {
        alert(resp.message);
      });
    },

    getDirection() {
      if (this.lead.latitude == null && this.lead.longitude == null) alert('lead Location not Updated');
      else window.open('https://www.google.com/maps/dir/Current+Location/' + this.lead.latitude + ',' + this.lead.longitude, '_system');
    },

    checkPermission() {
      Geolocation
        .checkPermissions()
        .then(e => {
          if (e.location != 'granted' && this.$store.state.platform != 'web') {
            Geolocation
              .requestPermissions('location')
              .then(this.getCurrentLocation)
              .catch(e => alert('Please check if GPS is turned On!'));
          } else {
            this.getCurrentLocation();
          }
        })
        .catch(e => alert('Please check if GPS is turned On!'));
    },

    getCurrentLocation() {
      Geolocation
        .getCurrentPosition({enableHighAccuracy: true})
        .then(pos => {
          this.map.setCenter([pos.coords.longitude, pos.coords.latitude]);
          this.marker.setLngLat([pos.coords.longitude, pos.coords.latitude]);
        })
        .catch(e => alert('Please check if GPS is turned On!'));
    },
  },

  mounted() {
    if (!this.$store.state.api_token || !this.$route.params.id) this.$router.go(-1);
    else this.setupMap();
  },

  unmounted() {
    this.map = null;
    this.marker = null;
  },
}
</script>
